export const VERSION = {
    git: "f35223c3"
}
